let _key = null;

export function storeEncryptionKey(cryptoKey) {
    _key = cryptoKey;
}

export function clearStoredKey() {
    _key = null;
}

export function hasEncryptionKey() {
    return _key !== null;
}

// Not an encrypted envelope (e.g. no session identifier server-side) — pass through as-is.
// If it IS an envelope but we have no key, or decryption fails (stale key from a rotated
// session), throw so the caller can refresh the key and retry instead of silently handing
// back the still-encrypted envelope as if it were the real payload.
export async function decryptPayload(response) {
    if (!response?.d || !response?.iv) return response;
    if (!_key) throw new Error('Encrypted payload received but no encryption key is available');

    const iv = Uint8Array.from(atob(response.iv), c => c.charCodeAt(0));
    const data = Uint8Array.from(atob(response.d), c => c.charCodeAt(0));
    const decrypted = await crypto.subtle.decrypt({ name: 'AES-GCM', iv }, _key, data);
    return JSON.parse(new TextDecoder().decode(decrypted));
}